<template>
    <div :class="{'disabled' : !active}">
        <p class="h3 reduce-margin">Contact Details</p>
        <p>We will use these details to contact you with updates regarding your order</p>

        <template v-if="active">
            <template v-if="editing">
                <div class="row">
                    <div class="col-md-6">
                        <div class="form-group">
                            <label for="contactEmail">Email address <span class="required">*</span></label>
                            <input id="contactEmail" class="form-control" v-model="cEmail" type="email">
                        </div>
                        <template v-if="errors['email']">
                         <div class="alert alert-danger"  v-for="(error, index) in errors['email']" :key="index">
                            {{ error }}
                        </div>
                        </template>
                    </div>
                    <div class="col-md-6">
                        <div class="form-group">
                            <label for="contactPhone">Phone Number <span class="required">*</span></label>
                            <input id="contactPhone" class="form-control" v-model="cPhone" type="tel">
                        </div>
                        <template  v-if="errors['phone']">
                        <div class="alert alert-danger" v-for="(error, index) in errors['phone']" :key="index">
                            {{ error }}
                        </div>
                        </template>
                    </div>
                    <div class="col-md-6" v-if="newsletterSignup">
                        <div class="checkbox checkbox--custom mb-0">
                            <label>
                                <input type="checkbox" v-model="subscribe">
                                <span class="faux-label">
                                    <strong class="faux-label__title">Subscribe to our promotional newsletter</strong><br>
                                    Receive great trade deals and new product launches, straight to your inbox.
                                </span>
                            </label>
                        </div>
                    </div>
                </div>
                <div class="row" v-if="guest && allowCreation">
                    <div class="col-md-12">
                        <div class="checkbox checkbox--custom">
                            <label>
                                <input type="checkbox" v-model="createAccount">
                                <span class="faux-label">
                                    <strong class="faux-label__title">Create an account</strong><br>
                                    Simply enter a password and we'll create you an account, ready for your next order!</span>
                                </span>
                            </label>
                        </div>
                    </div>
                </div>
                <template v-if="createAccount">
                    <br>
                    <div class="form-group row">
                        <div class="col-md-6">
                            <label>First Name</label>
                            <input type="text" v-model="firstname" class="form-control">
                            <p class="text-danger" v-if="errors['firstname']" v-for="(error, index) in errors['firstname']" :key="index">
                                {{ error }}
                            </p>
                        </div>
                        <div class="col-md-6">
                            <label>Last Name</label>
                            <input type="text" v-model="lastname" class="form-control">
                            <p class="text-danger" v-if="errors['lastname']" v-for="(error, index) in errors['lastname']" :key="index">
                                {{ error }}
                            </p>
                        </div>
                    </div>
                    <div class="form-group row">
                        <div class="col-md-6">
                            <label>Password</label>
                            <input type="password" v-model="password" class="form-control">
                            <p class="text-danger" v-if="errors['password']" v-for="(error, index) in errors['password']" :key="index">
                                {{ error }}
                            </p>
                        </div>
                        <div class="col-md-6">
                            <label>Password Confirmation</label>
                            <input type="password" v-model="passwordConfirmation" class="form-control">
                            <p class="text-danger" v-if="errors['password_confirmation']" v-for="(error, index) in errors['password_confirmation']" :key="index">
                                {{ error }}
                            </p>
                        </div>
                    </div>
                </template>
                <hr>
                <div class="row">
                    <div class="col-md-12 text-danger" v-if="registerError">
                        We are unable to create your account at this time.
                    </div>
                    <div class="col-md-12 text-right">
                        <button class="btn btn-green" @click="process" :disabled="processing">
                            <template v-if="!processing">
                                Save Details
                            </template>
                            <template v-else>
                                <i class="fa fa-refresh fa-spin"></i> Saving
                            </template>
                        </button>
                    </div>
                </div>
            </template>
            <template v-else>
                <button class="btn btn-xs btn-grey btn--position-right" @click="editing = true">Change details</button>
                <strong>Email:</strong> {{ cEmail }} <br>
                <strong>Phone:</strong> {{ cPhone }}
            </template>
        </template>
    </div>
</template>

<script>
    import Order from '../../Services/Order.js';
    import Checkout from '../../Services/Checkout.js';
    import Auth from '../../Services/Auth.js';
    import Marketing from '../../Services/Marketing.js';

    export default {
        props: {
            allowCreation: {
                type: Boolean,
                default: true
            },
            newsletterSignup: {
                type: Boolean,
                default: true
            },
            email: {
                type: String,
                default: null,
            },
            phone: {
                type: String,
                default: null,
            },
            step: {
                type: String,
                default: 1,
            },
            guest: {
                type: Boolean,
                default: true,
            }
        },
        data() {
            return {
                editing: true,
                service: Order,
                cEmail: null,
                cPhone: null,
                checkout: Checkout,
                processing: false,
                errors: [],
                createAccount: false,
                registerError: false,
                password: null,
                passwordConfirmation: null,
                firstname: null,
                lastname: null,
                subscribe: false,
            }
        },
        mounted() {
            this.firstname = this.service.shippingAddress.firstname;
            this.lastname = this.service.shippingAddress.lastname;
            this.cEmail = this.email;
            this.cPhone = this.phone;
            if (this.email && this.phone) {
                this.editing = false;
                this.save();
            }
        },
        watch: {
            checkoutStep(val) {
                if ((val == this.step) && !this.editing) {
                    this.checkout.next();
                }
            },
            email(val) {
                if (!this.cEmail) {
                    this.cEmail = val;
                }
            },
            phone(val) {
                if (!this.cPhone) {
                    this.cPhone = val;
                }
            }
        },
        computed: {
            active() {
                return this.checkout.step >= this.step;
            },
            checkoutStep() {
                return this.checkout.step;
            }
        },
        methods: {
            process() {
                this.processing = true;
                this.errors = [];
                this.registerError = false;
                if (this.createAccount) {
                    this.register();
                } else {
                    this.save();
                }
            },
            setContact() {
                this.service.setContact(this.cEmail, this.cPhone).then(response => {
                    this.editing = false;
                    this.processing = false;
                    if (this.checkoutStep == this.step) {
                        this.checkout.next();
                    }
                }).catch(errors => {
                    this.errors = errors.errors;
                    this.processing = false;
                });
            },
            register() {
                Auth.register({
                    email: this.cEmail,
                    password: this.password,
                    password_confirmation: this.passwordConfirmation,
                    firstname: this.firstname,
                    lastname: this.lastname,
                }).then(response => {
                    Auth.login(this.cEmail, this.password).then(response => {
                        this.save();
                    });
                }).catch (errors => {
                    if (errors.response.data.errors) {
                        this.errors = errors.response.data.errors;
                    } else {
                        this.registerError = true;
                    }
                    this.processing = false;
                });
            },
            /**
             * Subscribe the user to the list
             */
            subscribeToList() {
                return Marketing.subscribe(this.cEmail).then(response => {
                    this.setContact();
                }).catch(errors => {
                    this.setContact(); // If it fails, still proceed with the checkout.
                });
            },
            save() {
                this.errors = [];
                this.processing = true;
                if (this.subscribe) {
                    this.subscribeToList();
                } else {
                    this.setContact();
                }
            }
        }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// resources/assets/js/Components/Checkout/ContactDetails.vue